import { useEffect, useState } from 'react';
import { BrandMark } from '../components/BrandMark';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../api';
import { AuthCardSkeleton, ErrorNotice, ThemeToggle } from '../components/ui';

/** VerifyEmailPage spends an emailed verification token
 * (/verify-email?token=...) the moment it loads — the token is the proof
 * of ownership, no form to fill in. */
export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  const [state, setState] = useState<'pending' | 'verified' | 'error'>('pending');
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!token) {
      setState('error');
      setError(new Error('This verification link is missing its token.'));
      return;
    }
    let cancelled = false;
    api
      .verifyEmail(token)
      .then(() => {
        if (!cancelled) setState('verified');
      })
      .catch((cause: unknown) => {
        if (cancelled) return;
        setState('error');
        setError(cause instanceof Error ? cause : new Error(String(cause)));
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div className="auth-shell">
      <div className="auth-shell__theme">
        <ThemeToggle />
      </div>
      <div className="auth-card">
        <Link to="/" className="auth-card__brand">
          <BrandMark size={26} />
          Commerce Ops
        </Link>
        {state === 'pending' ? (
          <AuthCardSkeleton />
        ) : state === 'verified' ? (
          <>
            <h1>Email verified</h1>
            <Link className="button" to="/app">
              Go to dashboard
            </Link>
          </>
        ) : (
          <>
            <h1>Could not verify</h1>
            <ErrorNotice error={error} />
            <Link className="button button--secondary" to="/app">
              Go to dashboard
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
